'use server'

import { apiRequest, ApiResponse } from '../request'

/** Uma escrita que o assistente aplicou nesta resposta — cada uma pode ser desfeita. */
export interface AssistantAppliedAction {
    logId: string
    tool: string
    description: string
    catalogId: number
}

export interface AssistantReply {
    conversationId: string
    reply: string
    applied: AssistantAppliedAction[]
    /** O agente encerrou a conversa: o `conversationId` devolvido já é o novo. */
    conversationReset?: boolean
}

export interface AssistantAction {
    id: string
    description: string
    tool: string
    createdAt: string
    reverted: boolean
}

/**
 * Conversa com o assistente de catálogo. O histórico fica no servidor (Redis, 2h);
 * o front só carrega o `conversationId` para dar continuidade.
 */
export async function sendAssistantMessage(data: {
    message: string
    conversationId?: string
}): Promise<ApiResponse<AssistantReply>> {
    return apiRequest<AssistantReply>('catalog/assistant/message', { data }, 'post')
}

/** Encerra a conversa atual no servidor e devolve uma nova, vazia. */
export async function resetAssistantConversation(
    conversationId?: string
): Promise<ApiResponse<{ conversationId: string; conversationReset: boolean }>> {
    return apiRequest<{ conversationId: string; conversationReset: boolean }>(
        'catalog/assistant/reset',
        { data: { conversationId } },
        'post'
    )
}

export async function getAssistantActions(
    limit = 20
): Promise<ApiResponse<AssistantAction[]>> {
    return apiRequest<AssistantAction[]>('catalog/assistant/actions', {
        params: { limit },
    })
}

export async function undoAssistantAction(
    id: string
): Promise<ApiResponse<{ success: boolean; catalogId: number }>> {
    return apiRequest<{ success: boolean; catalogId: number }>(
        `catalog/assistant/actions/${id}/undo`,
        {},
        'post'
    )
}
